import React, { Component } from "react"
import LanguageSelection from '../components/LanguageSelection'
import Footer from '../components/Footer'

export default class Layout extends Component {

  isHomePage() {
    return this.props.location.pathname.match(/\/en(\/)?$/) || this.props.location.pathname.match(/\/it(\/)?$/);
  }

  render() {
    const lang = this.props.location.pathname.substring(1,3);
    return (
      <div style={{height: '100%'}}>
        <header>
          <div className="top-nav">
            <div className="container">
              <div className="row">
                <div className="col-sm-6 col-lg-6 ">
                  <ul>
                    <li><i className="fa fa-envelope-o" aria-hidden="true"></i> info@vedutaconsult.it</li>
                  </ul>
                </div>
                <div className="col-sm-6 col-lg-6 text-right">
                  <div className="top-social">
                    <ul>
                      <li>LinkedIn:</li>
                      <li><a href="https://www.linkedin.com/in/marco-scatto-6b54977/" title="Marco Scatto">Marco Scatto</a></li>
                      <li><a href="https://www.linkedin.com/in/enrico-vittadello-358b7b39/" title="Enrico Vittadello">Enrico Vittadello</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="mainNav" className={`navbar navbar-fixed-top ${ !this.isHomePage() ? '' : '' } affix-top`}>
            <div className="container">
              <div className="row">
                <nav className="navbar navbar-inverse navbar-default">

                  <div className="navbar-header">
                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                      <span className="sr-only">Toggle navigation</span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                    {
                      this.isHomePage()
                      ? <a className="navbar-brand" href="#"><img src="/images/logo.svg" alt="logo" style={{width: '140px'}} /></a>
                      : <a className="navbar-brand" href="#"><img src="/images/logo.svg" alt="logo" style={{width: '140px'}} /></a>
                    }
                  </div>
                  <div className="collapse navbar-collapse navbar-right" id="bs-example-navbar-collapse-1" data-hover="dropdown" data-animations="fadeIn fadeInLeft fadeInUp fadeInRight">
                    <ul className="nav navbar-nav">
                      <li>
                        <a href={ `/${lang}` }>Home</a>
                      </li>
                      <li>
                        <a href={ `/${lang}/about` }>{ lang == 'en' ? 'About us' : 'Chi siamo' }</a>
                      </li>
                      <li>
                        <a href="#" data-toggle="dropdown" aria-expanded="true">Aree d'intervento <i className="fa fa-angle-down" aria-hidden="true"></i></a>
                        <ul className="dropdown-menu arrow">
                          <li><a href={`/${lang}/management`}>Strategic Management</a></li>
                          <li><a href={`/${lang}/administration`}>Amministrazione e bilancio</a></li>
                          <li><a href={`/${lang}/finance`}>Finanza e tesoreria</a></li>
                          <li><a href={`/${lang}/supplychain`}>Supply Chain e Logistica</a></li>
                          <li><a href={`/${lang}/network`}>Sviluppo canali</a></li>
                          <li><a href={`/${lang}/organization`}>Organizzazione e processi</a></li>
                        </ul>
                      </li>
                      <li>
                        <a href={ `/${lang}/contact` }>{ lang == 'en' ? 'Contact' : 'Contatti' }</a>
                      </li>
                    </ul>
                    {/*<LanguageSelection lang={ lang } />*/}
                  </div>

                </nav>
              </div>
            </div>
          </div>
        </header>

        {this.props.children()}

        <Footer lang={ lang } />

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js